/* eslint-disable @typescript-eslint/no-explicit-any */

const UNIVERSAL_FOOTER_TYPE = 'mi-aem-homepage-spa/components/content/universal-footer';

/**
 * Recursively searches for an object with a specific ':type' value
 * @param obj - The object to search through
 * @param targetType - The ':type' value to find
 * @returns The matching object or null if not found
 */
function findObjectByType(obj: any, targetType: string): any | null {
  if (!obj || typeof obj !== 'object') return null;

  // Check if current object matches the target type
  if (obj[':type'] === targetType) {
    return obj;
  }

  // Search in ':items' if present (AEM model structure)
  if (obj[':items']) {
    for (const key of Object.keys(obj[':items'])) {
      const result = findObjectByType(obj[':items'][key], targetType);
      if (result) return result;
    }
  }

  // Search in direct children (for nested structures like experiencefragment)
  for (const key of Object.keys(obj)) {
    if (key !== ':items' && typeof obj[key] === 'object') {
      const result = findObjectByType(obj[key], targetType);
      if (result) return result;
    }
  }

  return null;
}

/**
 * Extracts the universal footer model from the AEM page model.
 * Searches within 'footer-responsivegrid' for the universal_footer component.
 *
 * @param model - The full AEM page model (pageProps.model)
 * @returns The universal footer model object or null if not found
 *
 * @example
 * // In a component:
 * const universalFooter = extractUniversalFooterModelFromPageModel(pageModel);
 * if (universalFooter) {
 *   // Use universalFooter.workwithusItems, universalFooter.privacyItems, etc.
 * }
 */
export function extractUniversalFooterModelFromPageModel(model: any): any | null {
  if (!model?.cqItems?.root?.[':items']?.['footer-responsivegrid']) {
    return null;
  }

  const footerGrid = model.cqItems.root[':items']['footer-responsivegrid'];
  return findObjectByType(footerGrid, UNIVERSAL_FOOTER_TYPE);
}
